<template>
    <div v-if="show" class="nibnut-overlay">
        <div class="loading loading-lg nibnut-overlay-content"></div>
    </div>
</template>

<script type="text/javascript">
export default {
    name: "Loader",
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>
